// extracted by mini-css-extract-plugin
module.exports = {"queue":"_1_QDc4"};